import * as React from 'react'
import * as cn from 'classnames'
import * as styles from './NavigationButton.module.scss'

interface NavigationButtonProps {
    direction: 'prev' | 'next'
    active: boolean
    onClick: (event: React.MouseEvent) => void
}

export const NavigationButton = (props: NavigationButtonProps) => 
    <button
        onClick={(event) => props.active && props.onClick(event)}
        className={cn(styles.button, {
            [styles.prev]: props.direction === 'prev',
            [styles.next]: props.direction === 'next',
            [styles.disabled]: !props.active
        })}
    >
        <svg width="18" height="32" viewBox="0 0 18 32" xmlns="http://www.w3.org/2000/svg" className={styles.icon}>
            <path d="M14.763 17.237v-2.474l-14 14c-.684.683-.684 1.79 0 2.474.683.684 1.79.684 2.474 0l14-14c.684-.683.684-1.79 0-2.474l-14-14C2.554.08 1.447.08.763.763c-.684.683-.684 1.79 0 2.474l14 14z" fillRule="nonzero" fill="#EFF1F1"/>
        </svg>
    </button>
